import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PartnerRecord, DataService, UserRecord } from '@core/services/data.service';
import { Filterable } from '@common/utilities/Filterable';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './partner-editor.component.html',
  styleUrls: ['./partner-editor.component.scss']
})
export class PartnerEditorComponent implements OnInit {

  @Input()
  public partner: PartnerRecord;

  @Output()
  public change = new EventEmitter<PartnerRecord>();

  public users = new Filterable<UserRecord>({
    extractor: i => [i.Username]
  });

  constructor(private ds: DataService, private modal: ModalService) { }

  ngOnInit(): void {

    this.partner = this.partner ? { ...this.partner } : { ID: 0, Name: '', Address: '', Email: '', Phone: '', ImportPolicyID: 0, ExportPolicyID: 0, DealerID: 0 };

    this.ds.users('list').subscribe(users => this.users.source = users);
  }

  public close() {
    this.modal.of(this).hide();
  }

  public save() {

    this.partner.Name = this.partner.Name.split(' ').filter(i => i.length > 0).join(' ').toUpperCase();
    this.partner.Address = this.partner.Address.toLowerCase().split(' ').filter(i => i.length > 0).map(i => i.substr(0, 1).toUpperCase() + i.substr(1)).join(' ');

    this.ds.partners(this.partner.ID > 0 ? 'update' : 'create', this.partner).subscribe(results => {
      if (results && results.length == 1) {
        this.partner = results[0];
        this.change.emit(this.partner);
        this.modal.of(this).hide();        
      }
    });
  }
}
